import { Reducer } from "redux";
import * as actions from "./adminUserActions";
import { AdminUser } from "../../service/api-response/AdminUserSuccessResponse";
import { AdminUserListItem } from "../../service/api-response/AdminUsersSuccessResponse";
import { AdminErrorListResponseData } from "../../service/api-response/AdminFormErrorResponse";

export interface AdminUserState {
  list: {
    [orgKeyName: string]: undefined | AdminUserListItem[];
  };
  isLoadingList: {
    [orgKeyName: string]: undefined | boolean;
  };
  isLoadingUser: {
    [orgKeyName: string]: undefined | boolean;
  };
  user: {
    [orgKeyName: string]: undefined | AdminUser;
  };
  isUpserting: boolean;
  upsertErrors: AdminErrorListResponseData | undefined;
}

const initialState: AdminUserState = {
  list: {},
  isLoadingList: {},
  user: {},
  isLoadingUser: {},
  isUpserting: false,
  upsertErrors: undefined,
};

type SupportedActions =
  | actions.GetAdminUserAction
  | actions.GetAdminUserAction
  | actions.GetAdminUserFailAction
  | actions.GetAdminUserSuccessAction
  | actions.ListAdminUsersAction
  | actions.ListAdminUsersFailAction
  | actions.ListAdminUsersSuccessAction
  | actions.UpsertAdminUserAction
  | actions.UpsertAdminUserFailAction
  | actions.UpsertAdminUserSuccessAction;

export const adminUserReducer: Reducer<AdminUserState, SupportedActions> = (
  state = initialState,
  action
): AdminUserState => {
  switch (action.type) {
    case actions.LIST_ADMIN_USERS: {
      return {
        ...state,
        isLoadingList: {
          ...state.isLoadingList,
          [action.organization]: true,
        },
      };
    }
    case actions.LIST_ADMIN_USERS_FAIL: {
      return {
        ...state,
        isLoadingList: {
          ...state.isLoadingList,
          [action.organization]: false,
        },
      };
    }
    case actions.LIST_ADMIN_USERS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          [action.organization]: action.data.admin_users,
        },
        isLoadingList: {
          ...state.isLoadingList,
          [action.organization]: false,
        },
      };
    }
    case actions.GET_ADMIN_USER: {
      return {
        ...state,
        isLoadingUser: {
          ...state.isLoadingUser,
          [action.organization]: true,
        },
      };
    }
    case actions.GET_ADMIN_USER_FAIL: {
      return {
        ...state,
        isLoadingList: {
          ...state.isLoadingList,
          [action.organization]: false,
        },
      };
    }
    case actions.GET_ADMIN_USER_SUCCESS: {
      return {
        ...state,
        isLoadingUser: {
          ...state.isLoadingUser,
          [action.organization]: false,
        },
        user: {
          ...state.user,
          [action.organization]: action.data,
        },
      };
    }
    case actions.UPSERT_ADMIN_USER: {
      return {
        ...state,
        upsertErrors: undefined,
        isUpserting: true,
      };
    }
    case actions.UPSERT_ADMIN_USER_FAIL: {
      return {
        ...state,
        upsertErrors: action.errors,
        isUpserting: false,
      };
    }
    case actions.UPSERT_ADMIN_USER_SUCCESS: {
      return {
        ...state,
        isUpserting: false,
        upsertErrors: undefined,
      };
    }
    default: {
      return state;
    }
  }
};
